export const JWT_KEY = "brainy_access_token";
